import { render, staticRenderFns } from "./buyCardHome.vue?vue&type=template&id=4a6ec938&scoped=true&"
import script from "./buyCardHome.vue?vue&type=script&lang=js&"
export * from "./buyCardHome.vue?vue&type=script&lang=js&"
import style0 from "./buyCardHome.vue?vue&type=style&index=0&id=4a6ec938&lang=less&scoped=true&"
import style1 from "./buyCardHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ec938",
  null
  
)

export default component.exports